import { ReleaseInstructionCountryConfig } from '../config';

const PORT_INTERIOR_UNSTUFFING = "DEPOTAGE A L'INTERIEUR DU PORT";

const normalizeUnstuffingLabel = (value?: string) =>
  (value ?? '')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/['’`´]/g, "'")
    .replace(/\s+/g, ' ')
    .trim()
    .toUpperCase();

export const isEmptyYardDisabledByUnstuffing = ({
  unstuffingTypeValue,
  unstuffingTypeOptions = [],
  releaseInstructionConfig,
}: {
  unstuffingTypeValue?: string | number;
  unstuffingTypeOptions?: Array<{ value?: any; text?: string; label?: string }>;
  releaseInstructionConfig?: ReleaseInstructionCountryConfig;
}) => {
  if (!releaseInstructionConfig?.fields?.disableEmptyYardWhenUnstuffing) return false;

  const selected = unstuffingTypeOptions.find(
    (option) => String(option.value) === String(unstuffingTypeValue)
  );
  const selectedLabel = selected?.text ?? selected?.label ?? '';

  return (
    normalizeUnstuffingLabel(selectedLabel) ===
    normalizeUnstuffingLabel(PORT_INTERIOR_UNSTUFFING)
  );
};


export function checkPickupLocationValidity(
  containerArray: any[],
  selectedPickupLocationValue: { [s: string]: unknown },
  selectedTruckerName: { [s: string]: unknown },
  selectedDate: { [s: string]: null | string },
  options: {
    showPickupLocationFields: boolean;
    impHaulage: string | null;
    releaseInstructionConfig: ReleaseInstructionCountryConfig | undefined;
  }
) {
  const { showPickupLocationFields, impHaulage, releaseInstructionConfig } =
    options;

  if (!showPickupLocationFields) {
    return !!(Object.values(selectedDate)?.filter((n) => n).length > 0);
  }

  // no entries
  if (
    Object.values(selectedPickupLocationValue).findIndex(
      (n) => n && n !== '0'
    ) == -1
  )
    return false;

  // overstay
  const overstay = Object.entries(selectedPickupLocationValue).filter(
    ([k, v]) => v == '1002' && k !== 'location'
  );
  if (overstay.length > 0) {
    if (overstay.findIndex(([k]) => selectedDate?.[k]) === -1) return false;
  }

  // terminal
  const terminal = Object.entries(selectedPickupLocationValue).filter(
    ([k, v]) => v == '1001' && k !== 'location'
  );
  if (terminal.length > 0) {
    if (
      impHaulage !== 'Carrier Haulage' ||
      !releaseInstructionConfig?.fields?.carrierHaulageTerminal
    ) {
      if (
        terminal.findIndex(([k]) => selectedTruckerName?.[k]) ==
        -1
      )
        return false;
    }
  }

  // Blank
  const blank = Object.entries(selectedPickupLocationValue).filter(
    ([k, v]) => (!v || v == '0') && k !== 'location'
  );
  if (blank.length > 0) {
    if (
      blank.findIndex(
        ([k]) => selectedTruckerName?.[k] || selectedDate?.[k]
      ) != -1
    )
      return false;
  }

  return true;
}


